import React, { useContext } from 'react'

import { NotesContext } from '../context'
import { Index } from './Index/index'
import { Form } from './Form'
import { Destroy } from './Destroy'
import { Create } from './Create'
import { Import } from './Import'

export const Views = () => {
  const { state: { view } } = useContext(NotesContext)

  return (
    {
      index: () => <Index />,
      create: () => <Create />,
      form: () => <Form />,
      delete: () => <Destroy />,
      import: () => <Import />
    }[view || 'index']()
  )
}
